import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from '@heroicons/react/24/outline';

const CardDeepQuestions = ({ starter, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // console.log(">>>> CardDeepQuestions");
  // console.log(starter);
  // console.log("//// CardDeepQuestions");

  return (
    <div className="bg-black/20 p-4 rounded-lg">
      <div className=" bg-black/0 rounded-lg p-8 flex items-center">
        <div className="flex items-center justify-center w-12 h-12 border border-orange-300/80 text-orange-300/80 rounded-full mr-8 text-lg bg-black/10 font-medium">
          {index + 1}
        </div>
        <div className="font-normal text-zinc-50 text-lg flex-1">
          {starter.starter}
        </div>
      </div>

      <div className="flex justify-center ">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="relative z-10 flex items-center justify-center rounded-lg border 
            border-zinc-900 bg-black/10 hover:bg-black/30 py-5 text-orange-300/80 text-sm transition-all duration-300 px-4 mt-2 w-full"
          aria-label={isExpanded ? "Hide details" : "Show details"}
        >
          Unpack Why {isExpanded ? (
            <MinusIcon className="w-5 h-5 ml-3 text-orange-300/80" />
          ) : (
            <PlusIcon className="w-5 h-5 ml-3 text-orange-300/80" />
          )}
        </button>
      </div>

      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            {/* Starter Details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-normal mb-4 bg-black/20 rounded-lg p-8">
              <div className="text-zinc-50 col-span-2">
                <p className="font-normal text-lg text-orange-300/80">
                  Follow-up
                </p>
                <p className="text-zinc-300 text-base mt-2">
                  {starter.follow_up}
                </p>
              </div>

              <div className="text-zinc-50 col-span-2">
                <p className="font-normal text-lg text-orange-300/80">
                  Why It Works
                </p>
                <p className="text-zinc-300 text-base mt-2">
                  {starter.reasons}
                </p>
              </div>

              <div className="text-zinc-50 col-span-2">
                <p className="font-normal text-lg text-orange-300/80">
                  Key Language
                </p>
                <p className="text-zinc-300 text-base mt-2">
                  {starter.key_language}
                </p>
              </div>
            </div>

            {/* Related Insights */}
            {starter.related_insights && starter.related_insights.length > 0 && (
              <div className="mt-4">
                <div className="grid grid-cols-1 bg-black/20 rounded-lg p-4">
                  <div className="font-normal px-3 py-2 text-lg text-orange-300/80">
                    Deeper Insights
                  </div>
                  {starter.related_insights.map((insight, insightIndex) => (
                    <div key={insightIndex} className="p-3 rounded-md">

                      <h6 className="font-normal text-lg text-zinc-300 mb-2">
                        {insight.insight}
                      </h6>
                      <div className="space-y-2 text-sm mt-4">
                        <div>
                          <p className="font-medium text-zinc-50">
                            Significance
                          </p>
                          <p className="text-zinc-300 mt-2">
                            {insight.significance}
                          </p>
                        </div>
                        <div>
                          <p className="font-medium text-zinc-50">
                            Supporting Data
                          </p>
                          <p className="text-zinc-300 mt-2">
                            {insight.supporting_data}
                          </p>
                        </div>
                        <div className="text-zinc-50 col-span-2 pt-4">
                          {/* <p className="font-medium text-gray-700 dark:text-gray-300 text-left">
                            Sources:
                          </p> */}

                          {/* <p>
                            {insight.sources}
                          </p> */}

                          <div className="text-zinc-50 col-span-2">
                            {starter.sources && (
                              <ul className="text-left mt-2">
                                {
                                  // Case 1: starter.sources is an object with name and url (new format)
                                  (typeof starter.sources === 'object' && 
                                   starter.sources !== null && 
                                   !Array.isArray(starter.sources) && 
                                   typeof starter.sources.name === 'string' && 
                                   typeof starter.sources.url === 'string') ? (
                                    <li>
                                      <a
                                        href={starter.sources.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-sky-500 hover:text-sky-400 dark:text-sky-400 dark:hover:text-sky-300"
                                      >
                                        {starter.sources.name}
                                      </a>
                                    </li>
                                  ) : 
                                  // Case 2: starter.sources is an array of strings (existing format)
                                  Array.isArray(starter.sources) ? (
                                    starter.sources.map((source, i) => (
                                      // Ensure source is a string before rendering
                                      typeof source === 'string' && (
                                        <li key={i}>
                                          <a
                                            href={source}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-sky-500 hover:text-sky-400 dark:text-sky-400 dark:hover:text-sky-300"
                                          >
                                            {source}
                                          </a>
                                        </li>
                                      )
                                    ))
                                  ) : 
                                  // Case 3: starter.sources is a single string (existing format, ensuring it's displayed)
                                  typeof starter.sources === 'string' ? (
                                    <li>
                                      <a
                                        href={starter.sources}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-sky-500 hover:text-sky-400 dark:text-sky-400 dark:hover:text-sky-300"
                                      >
                                        {starter.sources}
                                      </a>
                                    </li>
                                  ) : null // Fallback: if starter.sources is truthy but not any of the above types, render nothing in the list
                                }
                              </ul>
                            )}
                          </div>

                          {/* <ul className="text-left">
                            {insight.sources && Array.isArray(insight.sources) && insight.sources.map((source, i) => (
                              <li key={i}>
                                <a
                                  href={source.url || source}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-sky-500 hover:text-sky-400 dark:text-sky-400 dark:hover:text-sky-300"
                                >
                                  {source.name || source}
                                </a>
                              </li>
                            ))}
                          </ul> */}

                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CardDeepQuestions; 